import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconLayoutLeft"><Path d="M8.5 3C7.11929 3 6 4.11929 6 5.5V18.5C6 19.8807 7.11929 21 8.5 21H18.5C19.8807 21 21 19.8807 21 18.5V5.5C21 4.11929 19.8807 3 18.5 3H8.5Z" fill="currentColor"/><Path d="M3.5 3C3.22386 3 3 3.22386 3 3.5V20.5C3 20.7761 3.22386 21 3.5 21C3.77614 21 4 20.7761 4 20.5V3.5C4 3.22386 3.77614 3 3.5 3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutLeft;
